import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup,Validators} from "@angular/forms";
import {
  Banco,
  IdEmpresa,
  ReporteConciliacion,
  StadardCode,
  TipoMovimiento
} from "../../models/recuadosBancario/ParamExtracionBanca";
import {DatosMaestrosService} from "../../../../services/datos-maestros.service";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {RecaudoBancarioService} from "../../services/recaudoBancario/recaudo-bancario.service";
import {Observable, Subscription} from "rxjs";
import {ApiResponse} from "../../../../model/interfaces/response";
import {moduloConciliacion, PAGE_VISUALIZER} from "../../diccionarios/constRecaudo"
import {ExcelServiceService} from "../../../portal-compras/services/excel-service.service";

@Component({
  selector: 'app-reporte-extracto-bancario',
  templateUrl: './reporte-extracto-bancario.component.html',
  styleUrls: ['./reporte-extracto-bancario.component.css']
})
export class ReporteExtractoBancarioComponent implements OnInit {

  formulario: FormGroup;

  private subscription: Subscription;
  private subscriptionOP: Subscription;
  public dataSourceBanco$ :Observable<ApiResponse<Banco[]>> ;
  public dataSourceEstado$ :Observable<ApiResponse<StadardCode[]>>;
  public dataSourceReporte$ :Observable<ApiResponse<ReporteConciliacion[]>> ;
  public moduloConciliacion = moduloConciliacion;

  cmbEmpresa: IdEmpresa[] = [];
  cmbBancos:  Banco[] = [];
  cmbTipoMovimiento : TipoMovimiento[] = [];
  cmbEstados : StadardCode[] = [];

  loadingGrid: boolean = false;
  listaVacia:  boolean = true;
  gridApi:        any;
  gridColumnApi:  any;
  rowSelection:   any;
  columnDefs:     any[];
  rowData:        any[] = [];
  constructor(private fb: FormBuilder,
              private _datosMaestros: DatosMaestrosService,
              private _utils: UtilsService,
              private _recaudoservice: RecaudoBancarioService,
              public excelService: ExcelServiceService) { }

  ngOnInit(): void {
    const $this = this;
    this.formulario = this.fb.group({
      idEmpresa: ['', Validators.required],
      idBanco: ['', Validators.required],
      cuentaBancaria: [''],
      tipo_movimiento: [''],
      status: [''],
      fechaExtracto_inicio: [''],
      fechaExtracto_fin: [''],
      fechaContable_inicio: [''],
      fechaContable_fin: [''],
      montoDesde: [''],
      montoHasta: [''],
      referencia: [''],
    });

    this.columnDefs = [
     // { field: "idEmpresa",filter: true ,sortable: true, width: 100},
      { field: "idBanco", headerName: "Banco", filter: true ,sortable: true,width: 100 },
      { field: "cuentaBancaria",filter: true ,sortable: true, width: 120},
      { field: "numeroExtracto",headerName: "#Extracto", filter: true ,sortable: true, width: 120},
      { field: "numeroReferencia",headerName: "#Referencia",filter: true ,sortable: true, width: 120},
      { field: "claveOperativa",filter: true ,sortable: true, width: 130},
      { field: "idConciBancaDeta",filter: true ,sortable: true,width: 120},
      { field: "fechaExtracto",filter: true ,sortable: true,
        width: 150,
        valueGetter: function (data) {
          return $this._utils.getFechaInputFormat(data.data.fechaExtracto)
        }
      },
      { field: "monto",filter: true ,sortable: true, width: 100},
      { field: "fechaContable",filter: true ,sortable: true,
        width: 150,
        valueGetter: function (data) {
          return $this._utils.getFechaInputFormat(data.data.fechaContable)
        }
      },
      { field: "status",filter: true ,sortable: true,
        width: 140,
        cellRenderer: params => {
          return $this.getBadgeStatus(params.value);//$this.getBadgeStatus(params.data.status);
        }
      },
      { field: "tipoMovExtracto",headerName: "Tipo Movimiento",filter: true ,sortable: true, width: 160,
        valueGetter: function (data) {
          return $this.findTiposMovimiento(data.data.tipoMovExtracto)
        }
      },
      { field: "documentRefBanco",headerName: "Doc.Bancario",filter: true ,sortable: true, width: 120},
      { field: "nombreBanco", headerName: "Nombre Banco", filter: true, sortable: true, width: 180 },
      { field: "usuarioCarga", headerName: "Usuario Carga", filter: true, sortable: true, width: 130 },
      { field: "nombreUserCarga", headerName: "Nombre Usuario", filter: true, sortable: true, width: 200 },
      { field: "fechaCarga", headerName: "Fecha Carga", filter: true, sortable: true, width: 180,
        valueGetter: function (data) {
          return $this._utils.getFechaHoraInput(data.data.fechaCarga)
        }
      }
    ];

    this.cargarEmpresa();
    this.setEstados();
    this.cargaTiposMovimeintos();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  ngOnDestroy() {
    console.log("Destroy");
    this.subscription?.unsubscribe();
    this.subscriptionOP?.unsubscribe();
  }
  cargarEmpresa() {
    this.subscription = this._datosMaestros.getAllEmpresas().subscribe((resp : IdEmpresa[]) => {
      console.log(resp);
      this.cmbEmpresa = resp;
    }, (error) => {
      this.cmbEmpresa = [];
      console.log(error);
    });
  }
  setBanco() {
    const  idEmpresa = this.formulario.get('idEmpresa').value;

    if (this._utils.IsNull(idEmpresa)) {
      console.log("Error: idBanco o idEmpresa no pueden ser vacios");
      return;
    }
    this.dataSourceBanco$ = this._recaudoservice.cargarBancoEmpresa(idEmpresa);

    this.subscriptionOP = this.dataSourceBanco$.subscribe((resp: ApiResponse<Banco[]>) => {
      this.cmbBancos = resp.respuesta;
      this.cmbBancos.unshift({
        "idEmpresa": "1001",
        "idBanco": "*",
        "idPais": "EC",
        "dscaBanco": "TODOS",
        "refBanco": "*",
        "status": true,
        "descripcionBanco": "* - TODOS",
        "listaCuentas": {
          "idEmpresa": "1001",
          "idBanco": "*",
          "idCuenta": "*",
          "cuentaBancaria": "*",
          "claveControl": null,
          "moneda": "USDN",
          "cuentaLibroMayor": "*",
          "status": true
        }
      });
    }, (error) => {
      this.cmbBancos = [];
      console.log(error);
    });
  }

  setCuenta() {
    this.formulario.get('cuentaBancaria').setValue(this.buscarCuentaBancaria(this.formulario.get('idEmpresa').value,
                                                                              this.formulario.get('idBanco').value));
  }

  buscarCuentaBancaria(idEmpresa: string, idBanco: string): string {
    if (this._utils.IsNull(idEmpresa) || this._utils.IsNull(idBanco)) {
      console.log("Error: idBanco o idEmpresa no pueden ser vacios");
      return " ";
    }
    const banco = this.cmbBancos.find(b => b.idEmpresa === idEmpresa && b.idBanco === idBanco);
    // Si el banco existe y tiene lista de cuentas
    if (banco && banco.listaCuentas) {
      return banco.listaCuentas.cuentaBancaria;
    }
    // Si no se encuentra el banco o la cuenta, retornar undefined
    return " ";
  }

  setEstados() {
    this.dataSourceEstado$ = this._recaudoservice.cargaEstadosConciliacion();

    this.subscriptionOP = this.dataSourceEstado$.subscribe((resp: ApiResponse<StadardCode[]>) => {
      this.cmbEstados = resp.respuesta;
    }, (error) => {
      this.cmbEstados = [];
      console.log(error);
    });
  }

  cargaTiposMovimeintos(){
    this.cmbTipoMovimiento = this._recaudoservice.getTiposMovimientos();
  }

  getReporte() {

    const params = {
      ...(this.formulario.get('idBanco').value && { idBanco: this.formulario.get('idBanco').value }),
      ...(this.formulario.get('idEmpresa').value && { idEmpresa: this.formulario.get('idEmpresa').value }),
      ...(this.formulario.get('cuentaBancaria').value && { cuentaBancaria: this.formulario.get('cuentaBancaria').value }),
      ...(this.formulario.get('status').value && { status: this.formulario.get('status').value }),
      ...(this.formulario.get('tipo_movimiento').value && { tipo_movimiento: this.formulario.get('tipo_movimiento').value }),
      ...(this.formulario.get('fechaExtracto_inicio').value && { fechaExtracto_inicio: this.formulario.get('fechaExtracto_inicio').value }),
      ...(this.formulario.get('fechaExtracto_fin').value && { fechaExtracto_fin: this.formulario.get('fechaExtracto_fin').value }),
      ...(this.formulario.get('fechaContable_inicio').value && { fechaContable_inicio: this.formulario.get('fechaContable_inicio').value }),
      ...(this.formulario.get('fechaContable_fin').value && { fechaContable_fin: this.formulario.get('fechaContable_fin').value }),
      ...(this.formulario.get('montoDesde').value && { montoDesde: this.formulario.get('montoDesde').value }),
      ...(this.formulario.get('montoHasta').value && { montoHasta: this.formulario.get('montoHasta').value }),
      ...(this.formulario.get('referencia').value && { referencia: this.formulario.get('referencia').value }),
    };

    this.dataSourceReporte$ = this._recaudoservice.getreporteConciliacion(params);

    this.subscriptionOP = this.dataSourceReporte$.subscribe((resp: ApiResponse<ReporteConciliacion[]>) => {
      this.rowData = resp.respuesta;
      this.loadingGrid = false;
      this.listaVacia = false
    }, (error) => {
      this.rowData = [];
      this.loadingGrid = false;
      this.listaVacia = true;
      console.log(error);
    });
  }

  resetForm() {
    this.formulario.reset();
  }

  findReporte() {
    console.log(this.formulario.value);
    this.loadingGrid = true;
    this.getReporte();
  }

  getBadgeStatus(data: any): any {
    if (data === 'NORMAL') {
      return `<span class="badge text-bg-primary">${data}</span>`;
    } else if (data === 'BLOQUEADO_POR_CONFIRMAR') {
      return `<span class="badge text-bg-warning">${data}</span>`;
    } else if (data === 'DESBLOQUEADO') {
      return `<span class="badge text-bg-success">${data}</span>`;
    } else {
      return `<span class="badge text-bg-secondary">${data}</span>`; // o cualquier otro valor por defecto
    }
  }

  exportAsExcel(): void {
    const  $this = this;
    this.excelService.exportToExcel(this.gridApi, {
      fileName: 'ReporteExtracto'+this._utils.getCurrentDateGuion()+'.xlsx',
      sheetName: 'Reporte Extracto',
      columns: [
        {
          header: 'IdEmpresa',
          key: 'idEmpresa', // field name here
          width: 15 // width of the column
        },
        {
          header: 'IdBanco',
          key: 'idBanco',
          width: 15
        },
        {
          header: 'Cuenta Bancaria',
          key: 'cuentaBancaria', // field name here
          width: 15 // width of the column
        },
        {
          header: '# Extracto',
          key: 'numeroExtracto',
          width: 15
        },
        {
          header: 'Doc. Referencia',
          key: 'numeroReferencia',
          width: 15,
        },
        {
          header: 'Clave Operativa',
          key: 'claveOperativa',
          width: 15,
        },
        {
          header: 'Id Conciliacion',
          key: 'idConciBancaDeta',
          width: 15,
        },
        {
          header: 'Fecha Extracto',
          key: 'fechaExtracto',
          width: 20,
          valueGetter: (row) => this._utils.getFechaInputFormat(row.fechaExtracto)
        },
        {
          header: 'Monto',
          key: 'monto',
          width: 15,
        },
        {
          header: 'Fecha Contable',
          key: 'fechaContable',
          width: 15,
          valueGetter: (row) => this._utils.getFechaInputFormat(row.fechaContable)
        },
        {
          header: 'Estado',
          key: 'status',
          width: 20,
        },
        {
          header: 'Tipo Movimiento',
          key: 'tipoMovExtracto',
          width: 20,
          valueGetter: (row) => this.findTiposMovimiento(row.tipoMovExtracto)
        },
        {
          header: 'Doc. Bancario',
          key: 'documentRefBanco',
          width: 15,
        },
        {
          header: 'Cedula Ordenante',
          key: 'identificacionOrdenante',
          width: 15,
        },
        {
          header: 'Nombre Ordenante',
          key: 'nombreOrdenante',
          width: 15,
        },
        {
          header: 'Nombre Banco',
          key: 'nombreBanco',
          width: 15,
        },
         {
          header: 'Usuario Carga',
          key: 'usuarioCarga',
          width: 15,
        },
        {
          header: 'Nombre Usuario Carga',
          key: 'nombreUserCarga',
          width: 25,
        },
        {
          header: 'Fecha Carga',
          key: 'fechaCarga',
          width: 25,
          valueGetter: (row) => this._utils.getFechaHoraGuionInput(row.fechaCarga)
        },
        {
          header: 'Horas',
          key: 'horas',
          width: 10,
        },
        {
          header: 'Minutos',
          key: 'minutos',
          width: 10,
        },
        {
          header: 'Periodo',
          key: 'periodo',
          width: 10,
        }

      ]
    });
  }

  findTiposMovimiento(data: any) :any{
     const label = this.cmbTipoMovimiento.find( x => x.codigo == data);
     return label ? label.descripcion : '';
  }

}
